import React, {useEffect} from "react";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import List from "@material-ui/core/List";
import {Link} from "react-router-dom";
import {makeStyles} from "@material-ui/core";
import {useHistory} from "react-router-dom";
import HomeIcon from '@material-ui/icons/Home';
import SearchOutlinedIcon from '@material-ui/icons/SearchOutlined';
import ReorderOutlinedIcon from '@material-ui/icons/ReorderOutlined';
import GroupOutlinedIcon from '@material-ui/icons/GroupOutlined';
import StorageService from "../services/StorageService";

const useStyles = makeStyles((theme) => ({
    linkStyle: {
        textDecoration: "none",
        color: "#000",
    }
}));

const ItemMenuList = (props) => {
    const classes = useStyles();
    const history = useHistory();
    const storageService = new StorageService();
    const [links, setLinks] = React.useState([]);

    useEffect(() => {
        loadMenu()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const loadMenu = async () => {
        let linksDefault = [
            {
                title: "Home",
                route: "/home",
                icon: <HomeIcon/>,
            },
            {
                title: "Buscas",
                route: "/search",
                icon: <SearchOutlinedIcon/>,
            },
            {
                title: "Meus Atendimentos",
                route: "/answered",
                icon: <ReorderOutlinedIcon/>,
            },
        ]
        const employe = await storageService.getObjectLocalStorage('employee');
        if (employe === null) {
            linksDefault.push(
                {
                    title: "Funcionários",
                    route: "/funcionarios",
                    icon: <GroupOutlinedIcon/>,
                }
            )
            setLinks(linksDefault)
        } else {
            setLinks(linksDefault)
        }
    }

    const {location: {pathname}} = history;
    let menuList = links.map((item, index) => (
        <Link to={item.route} className={classes.linkStyle} key={index}>
            <ListItem button selected={pathname === item.route}>
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText primary={item.title}/>
            </ListItem>
        </Link>
    ));

    return (
        <List>
            {menuList}
        </List>
    );
};

export default ItemMenuList;
